import Header from './Header';
import Footer from './Footer';


function Price(lang) {
    if(lang.lang==="pl"){
        return (
            <div className='App'>
                <Header />
                <div className='pricesbody'>
                    <div id='pricestext'>
                        <h1>Cennik</h1>
                        <br />
                    </div>
                    <div id='pricesgrid'>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price4.webp' />
                            <br />
                            <h3>Księgowość</h3>
                            <h1>od 300 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Prowadzenie ksiągowości</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Przygotowanie deklaracji podatkowych</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Przygotowanie Sprawozdań</h5></h2>
    
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price5.webp' />
                            <br />
                            <h3>Doradztwo w Rozwoju Biznesu</h3>
                            <h1>od 600 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Opracowanie strategii rozwoju</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Analiza rynku</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Poszukiwanie funduszy</h5></h2>
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price6.webp' />
                            <br />
                            <h3>Legalizacja Działalności Gospodarczej</h3>
                            <h1>od 300 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Rejestracja działalności gospodarczej</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Obsługa formalności prawnych</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Wybór formy opodatkowania</h5></h2>
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price7.webp' />
                            <br />
                            <h3>Legalizacja pobytu w Polsce</h3>
                            <h1>od 1000 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Karta pobytu z tytułu pracy, prowadzenia biznesu, nauki oraz inne postawy uzyskania</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Karta rezydenta długoterminowego</h5></h2>
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price8.webp' />
                            <br />
                            <h3>Legalizacja pracy w Polsce</h3>
                            <h1>od 300 PLN</h1>
                            <br />
    
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price9.webp' />
                            <br />
                            <h3>Uzyskanie obywatelstwa polskiego</h3>
                            <h1>od 300 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Uznanie za obywatela poskiego</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Nadanie obywatelstwa polskiego</h5></h2>
                        </div>
                        <br />
                    </div>
    
                </div>
                <Footer />
            </div>
        );
    }
    if(lang.lang==="ua"){
        return (
            <div className='App'>
                <Header />
                <div className='pricesbody'>
                    <div id='pricestext'>
                        <h1>Цінник</h1>
                        <br />
                    </div>
                    <div id='pricesgrid'>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price4.webp' />
                            <br />
                            <h3>БУХГАЛТЕРІЯ</h3>
                            <h1>від 300 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Ведення бухгалтеріі</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Підготовка податкових декларацій</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Підготовка річних звітів </h5></h2>
    
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price5.webp' />
                            <br />
                            <h3>КОНСАЛТИНГ</h3>
                            <h1>від 600 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Розробка стретегіі розвитку</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}> Аналіз ринку</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Пошук фінансування</h5></h2>
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price6.webp' />
                            <br />
                            <h3>ЛЕГАЛІЗАЦІЯ ПІДПРИЄМНИЦЬКОЇ ДІЯЛЬНОСТІ </h3>
                            <h1>від 300 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Реєстрація підприємницької діяльності</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Узгодження юридичних формальностей</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Вибір форми оподаткування</h5></h2>
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price7.webp' />
                            <br />
                            <h3>ЛЕГАЛІЗАЦІЯ ПЕРЕБУВАННЯ В ПОЛЬЩІ</h3>
                            <h1>від 1000 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>легалізація пербування на підставі праці, ведення бізнесу, навчання та інші підстави</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>резидент ЄС</h5></h2>
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price8.webp' />
                            <br />
                            <h3>ЛЕГАЛІЗАЦІЯ ПРАЦІ В ПОЛЬЩІ</h3>
                            <h1>від 300 PLN</h1>
                            <br />
    
                        </div>
                        <div className='prices'>
                            <img alt='pricesimg' src='/price9.webp' />
                            <br />
                            <h3>ОТРИМАННЯ ГРОМАДЯНСТВА </h3>
                            <h1>від 300 PLN</h1>
                            <br />
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Визнання польским громадянином</h5></h2>
                            <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Надання польского громадянства </h5></h2>
                        </div>
                        <br />
                    </div>
    
                </div>
                <Footer />
            </div>
        );
    }
    
}

export default Price;